import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';

import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { SalesOrders_ShellService, EModalSize, EToasterType, EToasterPosition } from './SalesOrders.shell.service';
import { SalesOrders_OperationService } from './SalesOrders.operation.service';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { SalesOrders_ReportService } from './SalesOrders.report.index';
import { SalesOrders_LocalizationService } from './SalesOrders.localization.service';
import { Language } from './localization.service';
import { $types } from './SalesOrders.types'

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'SalesOrders-salesorders_library_home',
  templateUrl: './SalesOrders.salesorders_library_home.component.html'
})
export class SalesOrders_salesorders_library_homeComponent implements OnInit, OnDestroy {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  formGroup: FormGroup = new FormGroup({
    contents: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
  };

  fields = {
    description: new FieldModel(new LabelModel(null, null)
, new ControlContainerStyles(null, null), 'Description', false)
,
    contents: new FieldModel(new TextBoxModel(this.formGroup.controls['contents'] as DatexFormControl, null, false, '')
, new ControlContainerStyles(null, null), 'Contents', false)
,
  };

  fieldsets = {
  newGroup1: new FieldsetModel('Sales orders library', false, true, true),
};

  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    contents: this.fields.contents.control.valueChanges
    ,
  }
  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: SalesOrders_ShellService,
private datasources: SalesOrders_DatasourceService,
private flows: SalesOrders_FlowService,
private reports: SalesOrders_ReportService,
private localization: SalesOrders_LocalizationService,
private operations: SalesOrders_OperationService,
) { 
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'Home';
  
    const $form = this;
    const $utils = this.utils;

    (this.fields.description.control as LabelModel).label = `Library to access Footprint sales orders, includes various grids, editors and forms to create, view and manipulate sales orders and their associated entities.`;
    


    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .contents
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }
 
}
